import { pathEq, pathOr } from "ramda";
export const learningSegmentsLoading = pathEq(["learningSegments", "status"], "loading");
export const learningSegmentsLoaded = pathEq(["learningSegments", "status"], "loaded");
export const getLearningSegmentsList = pathOr([], ["learningSegments", "segments"]);
